import * as types from "../actions/index";
export default function(state = null, action) {
  switch (action.type) {
    case types.CALL_BACK_TO_QUICK_LINK:
      return action.payload;
    // no default
  }
  return state;
}
